import React from "react";

const DisplayComments = ({ comments }) => {
  return (
    <>
      {comments.length > 0 && (
        <div className="border border-bkg2 my-4 p-4 bg-bkg rounded-md">
          <h5>Comments</h5>
          {comments.map((item, index) => (
            <div key={index} className="sm:flex sm:justify-between mb-5">
              <div>
                <h6 className="text-text-1/75 font-medium w-36">{item.name}</h6>
                <p className="text-text-1/60 text-xs">{item.role}</p>
                <p className="text-text-1/60 text-xs">{item.step}</p>
              </div>
              <div className=" rounded-md border border-bkg2 p-3 flex-1 sm:ml-5 text-text-1/60">
                <p
                  className={
                    item.role !== "System"
                      ? "text-orange-500/80 text-xs"
                      : "text-green-500 text-xs"
                  }
                >
                  {new Date(item.timestamp).toDateString()}
                </p>
                {/* <p className={item.role == "System" && "text-green-500"}> */}
                {item.comment}
                {/* </p> */}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default DisplayComments;
